// src/components/AuthRoute.jsx
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { selectAuth, selectIsInitialized } from '../store/slices/authSlice';
import CustomLoader from '../dashboard/components/CustomLoader';

const AuthRoute = () => {
  const { isAuthenticated, isLoading } = useAppSelector(selectAuth);
  const isInitialized = useAppSelector(selectIsInitialized);

  if (!isInitialized || isLoading) {
    return <CustomLoader message="Checking authentication..." />;
  }

  return isAuthenticated ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

export default AuthRoute;